import React, { lazy, useEffect, useState } from "react";

import {
  CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CForm, CFormCheck, CFormInput, CFormLabel, CFormText,
  CProgress,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow, CWidgetStatsA
} from "@coreui/react";
import { CChartBar, CChartLine } from "@coreui/react-chartjs";
import { getStyle, hexToRgba } from '@coreui/utils'
import CIcon from '@coreui/icons-react'
import {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibGoogle,
  cibFacebook,
  cibLinkedin,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cibTwitter,
  cilCloudDownload,
  cilPeople,
  cilUser,
  cilUserFemale, cilArrowBottom, cilOptions, cilArrowTop,cilTrash,cilPencil,
  cilChevronLeft, cilChevronRight
} from "@coreui/icons";

import avatar1 from 'src/assets/images/avatars/1.jpg'
import avatar2 from 'src/assets/images/avatars/2.jpg'
import avatar3 from 'src/assets/images/avatars/3.jpg'
import avatar4 from 'src/assets/images/avatars/4.jpg'
import avatar5 from 'src/assets/images/avatars/5.jpg'
import avatar6 from 'src/assets/images/avatars/6.jpg'
import { AppContent, AppFooter, AppHeader, AppSidebar } from "../../components";
import { Link, useHistory } from "react-router-dom";
import { dashboardService } from "../../services/dashboard.service";
import ReactPaginate from "react-paginate";
// import { authService } from "../services/auth.service";

const AllPlayers = () => {

  const [users, setUsers] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  let history = useHistory();

  useEffect(() => {
    allPlayers()
  }, []);

  let allPlayers = (e) => {
    let page = e?.selected ?? 0;
    dashboardService.allPlayers(page + 1).then(({data}) => {
      console.log(data);
      if (data.status_code == 200){
        setUsers(data.users.data)
        setTotalPage(data.users.last_page)
        console.log(data.users.data);
      }
    })

  }

  let deleteUser = (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Do you really want to delete?') ===  true){
      dashboardService.deletePlayer(id).then(({ data }) => {
        console.log(data);
        if (data.status_code == 200){
          allPlayers()
        }
      })
    }
  }

  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <div className="rt-themetableholder">
            <CTable striped>
              <CTableHead>
                <CTableRow>
                  {/* <CTableHeaderCell scope="col">#</CTableHeaderCell>s */}
                  <CTableHeaderCell scope="col"></CTableHeaderCell>
                  <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Email</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Team Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Last Login</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {users.map(user => {
                  return (<CTableRow key={user.id}>
                      {/* <CTableHeaderCell scope="row">{user.id}</CTableHeaderCell> */}
                    <CTableDataCell>
                      <figure className='rt-roundimage'>
                         <img src={user.profile_image} alt="" height={40} />
                      </figure>
                    </CTableDataCell>
                      <CTableDataCell>
                        <Link to={'/player/'+user.id+'/profile'}>{user.full_name}</Link>
                      </CTableDataCell>
                      <CTableDataCell>{user.email}</CTableDataCell>
                      <CTableDataCell>{user.team_name}</CTableDataCell>
                      <CTableDataCell>{user.last_login}</CTableDataCell>

                      <CTableDataCell>
                        <Link to={'/player/edit/'+user.id}>
                          <CIcon icon={cilPencil} />
                        </Link>
                        <button className="delete-icon" onClick={e => deleteUser(user.id)}>
                          <CIcon icon={cilTrash} />
                        </button>
                      </CTableDataCell>
                    </CTableRow>)
                })}
              </CTableBody>
            </CTable>
          </div>
          {totalPage > 1 ?
            <ReactPaginate
              previousLabel={<CIcon icon={cilChevronLeft} />}
              nextLabel={<CIcon icon={cilChevronRight} />}
              breakLabel={'...'}
              breakClassName={'page-item'}
              nextClassName={'rt-next page-item'}
              previousClassName={'rt-prev page-item'}
              pageCount={totalPage}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              previousLinkClassName={'page-link'}
              disabledClassName={'disabled'}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={(e) => allPlayers(e)}
              containerClassName={'rt-pagination pagination'}
              activeClassName={'active'}
            /> : ''}
        </div>
        {/* <AppFooter /> */}
      </div>
    </div>
  )
}

export default AllPlayers
